import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.497 11.251a2 2 0 0 0-2.963 1.579c-.354 4.136-.532 8.038-.534 11.704-.002 3.648.173 7.505.525 11.57a2.001 2.001 0 0 0 2.962 1.576l21.864-12.12a1.25 1.25 0 0 0 0-2.187L16.497 11.251Zm.97-1.749L39.32 21.624a3.25 3.25 0 0 1 0 5.685l-21.864 12.12a4 4 0 0 1-5.924-3.152c-.358-4.121-.535-8.036-.533-11.745.002-3.724.183-7.681.541-11.872a4 4 0 0 1 5.926-3.158Z",
    fill: "currentColor"
  }));
};

var SvgPlay = styled(SvgComponent).withConfig({
  displayName: "Play__SvgPlay",
  componentId: "sc-1qxlvte-0"
})(["", " ", ""], size, color);
export default SvgPlay;